import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { pageAPI } from "../services/api";
import { useLanguage } from "../i18n/LanguageContext";

// Rendu générique d'une page CMS (contenu édité depuis l'admin).
// Utilisé pour /p/:slug et pour les pages CGU (slug fixe via prop).
const DynamicPage = ({ slug: slugProp }) => {
  const params = useParams();
  const slug = slugProp || params.slug;
  const { lang, isRTL } = useLanguage();
  const ar = lang === "ar";

  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    setNotFound(false);
    pageAPI
      .show(slug)
      .then((res) => {
        const data = res && res.data && res.data.data ? res.data.data : null;
        if (alive) { setPage(data); if (!data) setNotFound(true); }
      })
      .catch(() => { if (alive) setNotFound(true); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [slug]);

  const title = page ? (ar && page.titleAr ? page.titleAr : page.title) : "";
  const html = page ? (ar && page.contentAr ? page.contentAr : page.content) : "";

  return (
    <div className="bg-white min-h-screen" dir={isRTL ? "rtl" : "ltr"}>
      <style>{`
        .cms-content h2 { font-size: 1.125rem; font-weight: 700; color: #111827; margin-top: 1.5rem; margin-bottom: .4rem; }
        .cms-content p { color: #374151; line-height: 1.7; margin-bottom: .5rem; }
        .cms-content ul { list-style: disc; padding-inline-start: 1.25rem; color: #374151; }
        .cms-content a { color: #e11d7b; text-decoration: underline; }
        .cms-content .cgu-notice { background:#fffbeb; border:1px solid #fde68a; color:#92400e; padding:.75rem 1rem; border-radius:.5rem; font-size:.875rem; margin-bottom:1rem; }
      `}</style>

      <div className="max-w-3xl mx-auto px-6 py-10">
        {loading ? (
          <p className="text-gray-400">{ar ? "جارٍ التحميل…" : "Chargement…"}</p>
        ) : notFound ? (
          <div className="text-center py-20">
            <h1 className="text-2xl font-bold text-gray-900">{ar ? "الصفحة غير موجودة" : "Page introuvable"}</h1>
            <p className="mt-2 text-gray-500">{ar ? "هذه الصفحة غير متوفرة." : "Cette page n'est pas disponible."}</p>
          </div>
        ) : (
          <>
            <h1 className="text-3xl font-extrabold text-gray-900">{title}</h1>
            {page && page.version && page.pageType !== "custom" && (
              <p className="mt-1 text-sm text-gray-500">{ar ? `النسخة ${page.version}` : `Version ${page.version}`}</p>
            )}
            <div
              className="cms-content mt-8"
              // contenu géré par l'admin uniquement
              dangerouslySetInnerHTML={{ __html: html || "" }}
            />
            <p className="mt-10 text-xs text-gray-400">Maxula — contact@maxula.ma</p>
          </>
        )}
      </div>
    </div>
  );
};

export default DynamicPage;
